import { withProducerContext } from 'gw-gateway-common-react';
import { TranslatorContext } from '@jutro/locale';
import { withViewModelService } from '@xengage/gw-portals-viewmodel-react';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import styles from './AdvancedFilter.module.scss';
import CategoryFilterCard from './CategoryFilterCard';
import PolicyLandingUtil from './PolicyLandingUtil';
import ProductFilterCard from './ProductFilterCard';

const policiesID = [
    'recentlyViewedTile',
    'recentlyIssuedTile',
    'delinquentTile',
];
class AdvancedFilter extends Component {
    static contextType = TranslatorContext;
    static propTypes = {
        producerCode: PropTypes.string,
        policyStatusCodes: PropTypes.shape([]).isRequired,
        policyLobs: PropTypes.shape([]).isRequired,
        counts: PropTypes.shape([]).isRequired,
        jobTypes: PropTypes.shape([]).isRequired,
        onValueChange: PropTypes.func.isRequired,
        clickedTile: PropTypes.func.isRequired,
        viewModelService: PropTypes.shape({
            create: PropTypes.func,
        }).isRequired,
    };

    static defaultProps = {
        producerCode: undefined,
    };

    util = null;

    state = {
        selectedCategory: undefined,
    };

    componentDidMount() {
        const { 
            policyStatusCodes, counts, 
            jobTypes, clickedTile, viewModelService 
        } = this.props;
        const translator = this.context;
        this.util = new PolicyLandingUtil(viewModelService, translator);
        const [customFilters, policyLineFilter] = this.util.getPolicySummaries(
            policyStatusCodes,
            clickedTile
        );
        let getDisplayValueForAdvFilter;
        const checkPolicyIDAvailability = policiesID.includes(clickedTile);
        if (checkPolicyIDAvailability) {
            getDisplayValueForAdvFilter = customFilters[0].displayValue;
        } else if (clickedTile === 'quotes') {
            getDisplayValueForAdvFilter = customFilters[1].displayValue;
        } else if (clickedTile === 'renewal') {
            getDisplayValueForAdvFilter = customFilters[2].displayValue;
        } else if (clickedTile === 'change') {
            getDisplayValueForAdvFilter = customFilters[3].displayValue;
        } else if (clickedTile === 'cancellation') {
            getDisplayValueForAdvFilter = customFilters[4].displayValue;
        }
        this.setState(
            {
                customFilters,
                policyLineFilter,
                selectedCategory: getDisplayValueForAdvFilter,
            },
            () => {
                this.filterCallback();
            }
        );
    }

    componentWillReceiveProps(nextProps) {
        const { selectedCategory } = this.state;
        const { producerCode, onValueChange, counts, jobTypes, policyLobs } = this.props;
        const { producerCode: newProducerCode } = nextProps;
        if (counts && jobTypes && producerCode && policyLobs) {
            const count = counts.find(jobType => jobType.producerCode == producerCode);
            this.util.initJobs(count, jobTypes, policyLobs);
        }
        if (producerCode !== newProducerCode) {
            const policy = {
                currentView: selectedCategory,
            };
            onValueChange(policy);
        }
    }

    onStatusValueChange = category => {
        this.setState({ selectedCategory: category }, () => {
            this.filterCallback();
        });
    };

    onProductFilterChange = value => {
        this.setState({ policyLineFilter: value }, () => {
            this.filterCallback();
        });
    };

    filterCallback = () => {
        const { selectedCategory, policyLineFilter } = this.state;
        const { onValueChange } = this.props;
        const policy = {
            currentView: selectedCategory,
            statusCodes: this.util.getStatusCodesForCurrentJobFilter(selectedCategory),
            billingStatusCodes: this.util.getBillingStatusCodesFilter(),
            lobCodes: this.util.getLobCodesFilter(),
        };
        onValueChange(policy);
    };

    render() {
        const { selectedCategory, customFilters, policyLineFilter } =
            this.state;
        if (!customFilters || !policyLineFilter || !selectedCategory) {
            return null;
        }
        return (
            <div className={styles.gw_advanced_filter}>
                <CategoryFilterCard
                    selectedCategory={selectedCategory}
                    customFilter={customFilters}
                    onValueChange={this.onStatusValueChange}
                    countInformation={this.util.policyCountInformation}
                />
                <ProductFilterCard
                    productProperties={policyLineFilter}
                    onValueChange={this.onProductFilterChange}
                />
            </div>
        );
    }
}

export default withViewModelService(withProducerContext(AdvancedFilter));
